module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_11.1175854b.jpg";